// extracted by mini-css-extract-plugin
module.exports = {"large":"layout_large__pJG6l","small":"layout_small__Q38rB"};